/**
 * Validates if a string is a valid URL
 */
export function isValidUrl(url: string): boolean {
  try {
    const urlObj = new URL(url);
    // Check for valid protocols
    return ['http:', 'https:', 'ws:', 'wss:'].includes(urlObj.protocol);
  } catch {
    return false;
  }
}

/**
 * Validates RPC URL format and protocol
 */
export function isValidRpcUrl(url: string): boolean {
  if (!url) return false;
  
  // Check basic URL validity
  if (!isValidUrl(url)) return false;
  
  try {
    const urlObj = new URL(url);
    
    // RPC URLs should use http/https or ws/wss
    if (!['http:', 'https:', 'ws:', 'wss:'].includes(urlObj.protocol)) {
      return false;
    }
    
    // Should have a hostname
    if (!urlObj.hostname) {
      return false;
    }
    
    // Warn about localhost in production
    if (process.env.NODE_ENV === 'production' && 
        (urlObj.hostname === 'localhost' || urlObj.hostname === '127.0.0.1')) {
      console.warn(`Using localhost RPC URL in production: ${url}`);
    }
    
    return true;
  } catch {
    return false;
  }
}

/**
 * Validates and sanitizes RPC URL
 */
export function validateRpcUrl(url: string, fallback: string): string {
  if (!url || !isValidRpcUrl(url)) {
    console.warn(`Invalid RPC URL: ${url}, using fallback: ${fallback}`);
    return fallback;
  }
  return url;
}

/**
 * Gets RPC URL with validation and fallback
 */
export function getRpcUrl(envVar: string | undefined, fallback: string): string {
  return validateRpcUrl(envVar || '', fallback);
}